import { render, staticRenderFns } from "./TFooter.vue?vue&type=template&id=0297c90b&scoped=true"
import script from "./TFooter.vue?vue&type=script&lang=js"
export * from "./TFooter.vue?vue&type=script&lang=js"
import style0 from "./TFooter.vue?vue&type=style&index=0&id=0297c90b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297c90b",
  null
  
)

export default component.exports